module.exports = __webpack_public_path__ + "img/wallet_02_complete_2.8356edee.png";